import React from 'react';
import { Headline, Subtext } from '../../components/ScreenShell';
import { PrimaryButton } from '../../components/ui/PrimaryButton';
import { AGE_OPTIONS } from '../../data/quizOptions';
import type { StepProps } from '../../types/quiz';
export function StepAge({
  profile,
  update,
  onNext
}: StepProps) {
  return <div className="flex flex-1 flex-col" data-id="element-91" data-mp="hy876xooqgxz">
      <Headline data-id="element-92" data-mp="hz9k77p9hdic">¿Cuántos años tiene {profile.child_name}?</Headline>
      <Subtext data-id="element-93" data-mp="mvhua6olqgin">Así ajustamos el lenguaje y el tono de sus audios.</Subtext>

      <div className="mt-7 grid grid-cols-4 gap-3" data-id="element-94" data-mp="rul19wo56wt9">
        {AGE_OPTIONS.map(age => {
        const selected = profile.child_age === age;
        return <button key={age} type="button" aria-pressed={selected} onClick={() => update({
          child_age: age
        })} className={`rounded-2xl border py-4 text-base font-semibold transition-all duration-200 active:scale-95 ${selected ? 'border-violet-500 bg-violet-500/10 text-violet-700 shadow-soft' : 'border-lavender-200 bg-white/90 text-ink shadow-soft'}`} data-id="element-95" data-mp="vv4sykpy5880">
              {age}
            </button>;
      })}
      </div>

      <div className="mt-auto pt-10" data-id="element-96" data-mp="12ao3nffwswys">
        <PrimaryButton onClick={onNext} disabled={!profile.child_age} data-id="element-97" data-mp="xbl3a8avjex5">
          Continuar →
        </PrimaryButton>
      </div>
    </div>;
}